import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { useGetRolePermissionsMutation } from "store/action/userRoleApi";
import { useGetAdminUserByTokenMutation } from "store/action/login";

const PermissionsContext = createContext({ allowedKeys: [], isLoaded: false, name: '', userId: null, role: null, refreshPermissions: () => { } });

export const PermissionsProvider = ({ children }) => {
  const [allowedKeys, setAllowedKeys] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);
  const [name, setName] = useState("");
  const [userId, setUserId] = useState(null);
  const [role, setRole] = useState(null);
  const [getRolePermissions] = useGetRolePermissionsMutation();
  const [getUser] = useGetAdminUserByTokenMutation();

  const fetchUserData = useCallback(() => {
    const token = localStorage.getItem("token");

    if (!token) {
      setIsLoaded(true);
      return;
    }

    setIsLoaded(false);

    getUser()
      .then((userResult) => {
        const userData = userResult?.data?.data ?? userResult?.data;
        const isActive = userData?.isActive;
        const userRole = userData?.role;

        if (isActive === false) {
          localStorage.removeItem("token");
          localStorage.removeItem("role");
          window.location.href = "/login";
          return;
        }
        setName(userData?.name || "");
        setUserId(userData?._id || userData?.id || null);
        if (userRole) {
          setRole(userRole);
          return getRolePermissions().then((result) => {
            const permissions = Array.isArray(result?.data?.data) ? result.data.data : [];
            const keys = permissions
              .filter((p) => Array.isArray(p.roles) && p.roles.includes(userRole))
              .map((p) => p.key);
            setAllowedKeys(keys);
          });
        }
      })
      .catch(() => { })
      .finally(() => setIsLoaded(true));
  }, [getUser, getRolePermissions]);

  useEffect(() => {
    fetchUserData();
  }, [fetchUserData]);

  return (
    <PermissionsContext.Provider value={{ allowedKeys, isLoaded, role, name, userId, refreshPermissions: fetchUserData }}>
      {children}
    </PermissionsContext.Provider>
  );
};

export const usePermissions = () => useContext(PermissionsContext);

export const IfHasPermission = ({ permissionKey, children, fallback = null }) => {
  const { allowedKeys, role } = usePermissions();
  const isAdmin = role === "Admin";
  const allowed = isAdmin || allowedKeys.includes(permissionKey);
  return allowed ? children : fallback;
};

